import type { ProductCategory } from '@jucy/rentals-api-client/rentals-api-v3/models/ProductCategory';
import type { ProductLine } from '@jucy/rentals-api-client/rentals-api-v3/models/ProductLine';

const amendableCategories: ProductCategory[] = [
    'SecondaryProduct',
    'FerryVehicleProduct',
    'FerryPassengerTicketProduct',
    'FerryAccommodationProduct',
];

export const isAmendableExtraLine = (line: ProductLine) =>
    amendableCategories.includes(line.category) && !line.isMandatory && !line.isExcluded && Boolean(line.qty) && Boolean(line.productCode);
